import { render, staticRenderFns } from "./com_captcha.vue?vue&type=template&id=69f00345&scoped=true"
import script from "./com_captcha.vue?vue&type=script&lang=js"
export * from "./com_captcha.vue?vue&type=script&lang=js"
import style0 from "./com_captcha.vue?vue&type=style&index=0&id=69f00345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f00345",
  null
  
)

export default component.exports